/**
 * The five soft goods the phlebotomist records a lot number for on every
 * donation, and how each one maps onto the processing record.
 *
 * `field` matches supply_types.phlebo_field in the catalog - that column, not
 * this file, decides which supply types feed which picker. Adding a second
 * bottle vendor is a setup change, not a code change.
 */
const SOFT_GOODS = [
    { field: 'CKIT', label: 'Plasmacell-C Kit', lotSource: 'lotnumber_ckit', qtySource: 'ckit' },
    { field: 'AC', label: 'Anti Coagulant', lotSource: 'lotnumber_ac', qtySource: 'qty_ac' },
    { field: 'SALINE', label: 'Saline', lotSource: 'lotnumber_saline', qtySource: 'qty_saline' },
    { field: 'BOTTLE', label: 'Bottle', lotSource: 'lotnumber_bottle', qtySource: 'qty_bottle' },
    { field: 'NEEDLE', label: 'Needle', lotSource: 'lotnumber_needle', qtySource: 'qty_needle' },
];

/** SOFT_GOODS keyed by field, for the odd direct lookup. */
export const SOFT_GOODS_BY_FIELD = SOFT_GOODS.reduce((acc, item) => {
    acc[item.field] = item;
    return acc;
}, {});

/**
 * Lot numbers as they are written to lotnumber_*: comma separated, and with
 * the count appended only when more than one unit of that lot was used, so
 * the common single-unit case still reads as a plain lot number on the
 * printed worksheet.
 *
 *   [{ lot_no: 'A12', qty: 1 }]                       -> 'A12'
 *   [{ lot_no: 'A12', qty: 2 }, { lot_no: 'B7', qty: 1 }] -> 'A12 (x2), B7'
 */
export const formatLotText = (lines) =>
    (lines || [])
        .filter(line => line && line.lot_no && line.qty > 0)
        .map(line => (line.qty > 1 ? line.lot_no + ' (x' + line.qty + ')' : line.lot_no))
        .join(', ');

/** Total units across the picked lots - what the Quantity used field shows. */
export const totalQty = (lines) =>
    (lines || []).reduce((sum, line) => sum + (Number(line.qty) || 0), 0);

export default SOFT_GOODS;
